(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BFCM-signup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
    // Target the div with class klaviyo-form-SJsN6p
    var klaviyoForm = document.querySelector('.klaviyo-form-Uth4Vy');

    // Check if the klaviyo form has any child elements
    if (klaviyoForm && klaviyoForm.children.length === 0) {
      // Create a container <div> for the message and the image
      var container = document.createElement('div');

      // Set the style for the container
      container.style.textAlign = 'center';
      container.style.paddingTop = '150px';
      container.style.display = 'flex';
      container.style.alignItems = 'center';
      container.style.justifyContent = 'center';

      // Create and append the text node to the container
      var message = document.createElement('span');
      message.textContent = 'You have already signed up ';
      container.appendChild(message);

      // Create and append the <img> element to the container
      var image = document.createElement('img');
      image.src = 'https://cdn-icons-png.flaticon.com/128/5610/5610944.png';
      image.alt = 'Signed up';
      // Optional: Set image size if needed
      image.style.width = '24px';
      image.style.height = '24px';
      image.style.marginLeft = '5px';
      container.appendChild(image);

      // Append the container to the klaviyo form
      klaviyoForm.appendChild(container);
    }
  }, 3000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-signup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
    // Target the div with class klaviyo-form-SJsN6p
    var klaviyoForm = document.querySelector('.klaviyo-form-SJsN6p');

    // Check if the klaviyo form has any child elements
    if (klaviyoForm && klaviyoForm.children.length === 0) {
      // Create a container <div> for the message and the image
      var container = document.createElement('div');

      // Set the style for the container
      container.style.textAlign = 'center';
      container.style.paddingTop = '150px';
      container.style.display = 'flex';
      container.style.alignItems = 'center';
      container.style.justifyContent = 'center';

      // Create and append the text node to the container
      var message = document.createElement('span');
      message.textContent = 'You have already signed up ';
      container.appendChild(message);

      // Create and append the <img> element to the container
      var image = document.createElement('img');
      image.src = 'https://cdn-icons-png.flaticon.com/128/5610/5610944.png';
      image.alt = 'Signed up';
      // Optional: Set image size if needed
      image.style.width = '24px';
      image.style.height = '24px';
      image.style.marginLeft = '5px';
      container.appendChild(image);

      // Append the container to the klaviyo form
      klaviyoForm.appendChild(container);
    }
  }, 3000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var quotesContainer = document.querySelector('.testimonial-quotes');
  var quotes = document.querySelectorAll('.testimonial-quotes p');
  var totalWidth = 0;

  // Clone all quotes and append them to the container
  quotes.forEach(function(quote) {
    var clone = quote.cloneNode(true);
    quotesContainer.appendChild(clone);
    totalWidth += quote.offsetWidth;
  });

  var scrollAmount = 0;
  var scrollPerFrame = 1; // Adjust this value for faster or slower speed

  function slideQuotes() {
    if (scrollAmount >= totalWidth) {
      // Reset scroll position to start
      quotesContainer.scrollLeft = 0;
      scrollAmount = 0;
    } else {
      quotesContainer.scrollBy(scrollPerFrame, 0);
      scrollAmount += scrollPerFrame;
    }
    window.requestAnimationFrame(slideQuotes);
  }

  window.requestAnimationFrame(slideQuotes);
});


  } catch(e) { console.error(e); }
})();
})();
